// function isValidDomain(origin, customDomain = '') {
//   // Domain and api domain
//   const params = new URLSearchParams(window.location.search);
//   const env = params.get('env') || '';
// let allowedOrigins = [
//     'https://www.gevme.com',
//     'https://showcase-dev.gevme.com',
//     'https://showcase-dev.gev.me',
//     'https://showcase.gev.me',
//     'https://live.gev.me',
//     'https://live-dev.gevme.com',
//     'https://live.gevme.com',
//     'https://admin.gevme.com',
//     'https://admin.gev.me',
//     'https://admin-dev.gevme.com',
//   ];

//   if (
//     (process.env.NODE_ENV === 'development' ||
//       process.env.NODE_ENV === 'LOCAL') &&
//     env === 'localhost'
//   ) {
//     allowedOrigins.push('http://localhost:3001');
//   }

//   if (customDomain) {
//     allowedOrigins.push(customDomain);
//   }

//   return allowedOrigins.some((domain) => origin === domain);
// }

function handleMessagePoll(event) {
  // handle event message
  if (isValidDomain(event.origin, window?.GEVME?.setting?.customDomain)) {
    try {
      if (document.getElementById('GevmePoll')) {
        var pollMsg = JSON.parse(event.data);
        if (pollMsg['GevmePoll']) {
          document.getElementById('GevmePoll').style.display =
            pollMsg['GevmePoll'].display;
          document.getElementById('GevmePoll').style.height =
            pollMsg['GevmePoll'].height;

          if (
            pollMsg['GevmePoll'].display == 'block' &&
            pollMsg['GevmePoll'].height == '50px'
          ) {
            document.getElementById('GevmePoll').contentWindow.postMessage(
              JSON.stringify({
                GevmePoll: {
                  height: '50px',
                },
              }),
              '*'
            );
          }
          if (
            pollMsg['GevmePoll'].type === 'floating' &&
            pollMsg['GevmePoll'].display == 'block'
          ) {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.webkitExitFullscreen) {
              /* Safari */
              document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
              /* IE11 */
              document.msExitFullscreen();
            }
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
}
class GevmePoll extends HTMLElement {
  constructor() {
    super();
  }
  attachPollMessageEvent() {
    window.addEventListener('message', handleMessagePoll);
  }
  connectedCallback() {
    var iframe = document.createElement('iframe');
    //eventually the base URI needs to be updated to /widgets

    var redirectBaseURI = `${
      window?.GEVME?.setting?.customDomain || process.env.TEMPLATE_APP_DOMAIN
    }/widgets`;
    var width = '700px',
      mode,
      showHeader;

    try {
      var pollObj = JSON.parse(this.getAttribute('settings'));
      width = pollObj.polls.style.width;
      mode = pollObj.mode || 'dark';
      showHeader = pollObj.showHeader || 'true';
    } catch (error) {}

    iframe.id = 'GevmePoll';
    iframe.name = 'GevmePoll';
    iframe.title = 'Gevme Poll';
    iframe.sandbox =
      'allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation allow-downloads allow-modals allow-presentation allow-same-origin';
    iframe.allowFullScreen = true;
    iframe.seamless = true;
    iframe.loading = 'lazy';
    iframe.referrerPolicy = 'no-referrer';
    iframe.src =
      `${redirectBaseURI}/polls?mode=${mode}&showHeader=${showHeader}` +
      `&slug=${window?.GEVME?.livepage?.slug}` +
      `${window?.GEVME?.isPreview ? '&isPreview=true' : ''}`;
    iframe.width = width;
    iframe.height = '50px';
    iframe.frameBorder = '0';
    iframe.style.borderRadius = '5px';
    iframe.style.display = 'none';
    iframe.style.width = '100%';
    iframe.onload = () => {
      document.getElementById('GevmePoll').contentWindow.postMessage(
        JSON.stringify({
          action: 'gevme-json',
          data: JSON.stringify(window.GEVME),
        }),
        '*'
      );
    };
    this.append(iframe);
    this.attachPollMessageEvent();
  }
}
window.customElements.define('gevme-poll', GevmePoll);
